import { jsxs as e, jsx as l } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
          fill: "#F2DFE1"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M66.3336 75H33.6664C31.0895 75 29 72.1347 29 68.6V33.4C29 29.8653 31.0895 27 33.6664 27H66.3336C68.9105 27 71 29.8653 71 33.4V68.6C71 72.1347 68.9105 75 66.3336 75Z",
          fill: "white",
          stroke: "var(--plac-primary-gray)",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M54 32C54 24.269 60.268 18 68 18C75.731 18 82 24.269 82 32C82 39.732 75.731 46 68 46C60.268 46 54 39.732 54 32Z",
          fill: "var(--plac-status-error)"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.6686 25.5L69.1777 34.7853H66.8292L66.3383 25.5H69.6686ZM69.2258 39.2189C68.9307 39.5072 68.52 39.6513 67.9938 39.6513C67.4548 39.6513 67.0377 39.5103 66.7426 39.2284C66.4474 38.9464 66.2998 38.5488 66.2998 38.0356C66.2998 37.5034 66.4442 37.1011 66.7329 36.8286C67.0217 36.5562 67.442 36.42 67.9938 36.42C68.5264 36.42 68.9387 36.5594 69.2306 36.8381C69.5226 37.1169 69.6686 37.5161 69.6686 38.0356C69.6686 38.5362 69.521 38.9306 69.2258 39.2189Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M51 43H49V56.5857L43.7072 51.2929L42.293 52.7071L49.293 59.7071L50.0001 60.4142L50.7072 59.7071L57.7072 52.7071L56.293 51.2929L51 56.5859V43Z",
          fill: "var(--plac-primary-gray)"
        }
      ),
      /* @__PURE__ */ l("path", { d: "M43 65L57 65", stroke: "var(--plac-primary-gray)", strokeWidth: "2" })
    ]
  }
);
export {
  r as DownloadAlertIllustration
};
//# sourceMappingURL=index.es499.js.map
